
import userConsole from './views//userConsole.html';
import template from './views/csvUpload.html';
import csvEntries from './views/csv-entries.html'
import './wizard.scss'

import './views/csv-upload.scss'
import ngFileUpload from 'ng-file-upload';

const name = 'userConsole';

import wizardStatus from './wizard'
// const mongoose = require('mongoose');
class UserConsole {

    constructor($scope,  $mdDialog, $mdToast, $mdMedia, $state,
         $element, $attrs, $compile, $rootScope, $timeout, localStorageService, 
         authService, CONSTANTS) {
        'ngInject';
       
        let self = this;
        $rootScope.title = "User Console"
        self.rolesToLoad = []
        self.selectedCurriculum = [];
        self.enableRoleList = false;
        self.enableNewRoleBtn = false;
        self.enableNewRoleDiv = false;
        var localSchoolId = localStorageService.get('school_id')
        var localMyUserId = localStorageService.get('user_id')
        $scope.btnLabel = "Save";
        $scope.showWizard = false;
        $scope.isReportingObj = false;
        // $scope.subscribe('getRoleMappings')
        $scope.allRoleCounts = []
        $scope.setCounts = () => {
            
            let sendObj = {schoolId : localSchoolId}
            authService.callAPI("/v0/initial-settings/user-console/user/management/"+localSchoolId, "GET", 
            sendObj, function (response) {
                try{
                    console.log(response)
                    if(!response.error){
                        $scope.allRoleCounts = response.result.data.data.rolecounts
                        // if(!$scope.allRoleCounts.Student){
                        //     $scope.allRoleCounts.Student = {}
                        //     $scope.allRoleCounts['Student']['detailedcount'] = response.result.data.data.studentData
                            
                        // }
                        $scope.detailedcount = response.result.data.data.studentData
                        console.log($scope.allRoleCounts)
                    }else{
                    console.log(response.error) 
                    }
                    getUserPrivilageInitialSetting()
                }catch(e){
                    console.log(e)
                }
                
            })
            // Meteor.call("getAddedRolesCount", Session.get('school_id'), localStorage.getItem('activeAcdYear'), (err, res) => {
            //     if (res) {
            //         $scope.allRoleCounts = res
            //     }
            // })
        }
        let setSettings = () => {
            self.curriculumPackage = [$scope.allSettingRole]

            self.selectedRoles = _.filter(self.curriculumPackage[0].list, function(role) {
                return role.name != 'Master Admin' && role.status === true
            })

            let ToLoad = _.filter(self.curriculumPackage[0].list, function(role) {
                return role.name != 'Master Admin' && role.status === false
            })

            // self.rolesToLoad = _.filter(self.curriculumPackage[0].list, function(role) {
            //     return role.name != 'Admin' && role.status === false
            // })


            // let role = _.filter(self.rolesToLoad, function(role) {
            //      return _.filter(self.selectedCurriculum, function(selectedRole) {
            //          return selectedRole.name != 'Admin' && selectedRole.status === false && role._id!=selectedRole._id 
            //      })
            //  })

            if (self.selectedCurriculum === undefined || self.selectedCurriculum.length === 0) {
                self.rolesToLoad = ToLoad
            } else {
                _.each(ToLoad, function(v) {
                    _.each(self.selectedCurriculum, function(k) {
                        if (v._id != k._id) {
                            self.rolesToLoad.push(v)
                        }
                    })
                })
            }

        }

        let getRoleSettings = () => {
            setSettings()
        }
        let sendObj = {schoolId : localSchoolId}
        authService.callAPI("/v0/initial-settings/user-console/roles/all/"+localSchoolId, "GET", 
        sendObj, function (response) {
            try{
                console.log(response)
                if(!response.error){
                    $scope.allSettingRole = response.result.data.data
                    self.allSettingRole = response.result.data.data
                    console.log(self.allSettingRole)
                    
                    if(response.result.data.mapping_roles){
                        $scope.reportingObj = response.result.data.mapping_roles
                        if ($scope.reportingObj)
                            $scope.isReportingObj = true;
                        else {
                            $scope.isReportingObj = false;
                            $scope.userdata = undefined
                            $scope.headRole = undefined
                        }
                    }
                    getRoleSettings();
                    $scope.setCounts()
                }else{
                    console.log(response.error)
                }
            }catch(e){
                console.log(e)
            }
        })
        // $scope.autorun(() => {
        //     $scope.reportingObj = ReportingRolesMapping.findOne({
        //         school_id: localStorageService.get('school_id')
        //     })
        //     if ($scope.reportingObj)
        //         $scope.isReportingObj = true;
        //     else {
        //         $scope.isReportingObj = false;
        //         $scope.userdata = undefined
        //         $scope.headRole = undefined
        //     }

        // })
        let subsSetting = undefined;

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "User Console"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            //subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
        }

        this.$onDestroy = () => {
            if (subsSetting)
                subsSetting.stop()

            self.rolesToLoad = undefined
            self.selectedRoles = undefined
            $scope.allRoleCounts = undefined
        }

        
        function getUserPrivilageInitialSetting(){
            let send = {
                userId : localMyUserId,
                schoolId : localSchoolId}
            authService.callAPI("/v0/initial-settings/user-console/getUserPrivilageInitialSetting", "POST", 
            send, function (response) {
                try{
                    if(!response.error){
                        self.checkintialSettingValue(response.result.data.data.initial_settings)
                    }else{
                        console.log(response.error)
                    }
                }catch(e){
                    console.log(e)
                }
            })
        }
        // self.call('getUserPrivilageInitialSetting', Meteor.userId(), Session.get('school_id'), (error, result) => {
        //     if (result) {
        //         self.checkintialSettingValue(result.initial_settings)
        //     }
        // })

        self.checkintialSettingValue = function(val) {
            $scope.tabStats = {}
            for (var i = 1; i <= 5; i++) {
                if (i <= val) {
                    $("#prop" + i).removeClass('disabled');
                } else {
                    $scope.tabStats['tab' + i] = "disabled";
                }
            };
            if (val < 5) {
                $scope.showWizard = true;
                $scope.btnLabel = "Next"
            }
        }

        

        


        this.getCountFromChild = function() {
            $scope.setCounts()
        }

        

        

        self.showRoleList = function() {
            self.enableRoleList = self.enableRoleList === false ? true : false;
        }

        self.addRoleEnable = function() {
            self.enableNewRoleDiv = self.enableNewRoleDiv === false ? true : false;
            self.enableNewRoleBtn = self.enableNewRoleDiv;
        }

        self.addNewRole = function() {

            if (!self.newRoles || self.newRoles.trim() === '') {
                toastr.error("Please enter role name");
                return false
            } else if (_.find(self.curriculumPackage[0].list, (ex) => {
                    return ex.name.toLowerCase() == self.newRoles.toLowerCase()
                })) {
                toastr.error("Role already exist");
                return false
            }
            let randId = Math.random().toString(36).substr(2, 10);
            self.selectedCurriculum.push({
                _id: randId,
                status: false,
                name: self.newRoles
            });
            // var schoolId = req.body.schoolId
            // var roleName = req.body.roleName
            let send = {
                schoolId : localSchoolId,
                roleName : self.newRoles
            }
            authService.callAPI("/v0/initial-settings/user-console/roles/new/save", "POST", 
            send, function (response) {
                try{
                    if(!response.error){
                        self.enableNextBtn = true;
                    }else{
                        console.log(response.error)
                        if (response.error) {
                            if (response.error.error === 'rolePackageError') {
                                toastr.error("Invalid Data to server.");
                            } else {
                                toastr.error("Please try after some time.");
                            }
                        }
                    }
                }catch(e){
                    console.log(e)
                }
            })
            self.newRoles = '';

        }

        self.deleteRole = function(role) {

            var confirm = $mdDialog.confirm()
                .title('Delete Role?')
                .textContent('Are you sure you want to delete this Role?')
                .ariaLabel('Confirm delete')
                .ok('Yes')
                .cancel('Cancel');
            let send = {
                school_id : localSchoolId,
                role : role
            }
            $mdDialog.show(confirm).then(function() {
                authService.callAPI("/v0/initial-settings/user-console/deleteRoleFromRolePriv", "POST", 
                {args:send}, function (response) {
                    try{
                        console.log(response)
                        if(response.error){
                            toastr.error("Please try after some time.");
                        }else{
                            let res = response.result.data.data
                            if (res) {
                                $scope.setCounts()
                                toastr.success("Role deleted sucessfully");
                            } else {
                                toastr.error('Cannot delete.Users are already assigned');
                            }
                        }
                    }catch(e){
                        console.log(e)
                    }
                })
                // Meteor.call("deleteRoleFromRolePriv", role, Session.get('school_id'), function(err, res) {
                //     if (err) {
                //         toastr.error("Please try after some time.");

                //     } else {

                //         if (res) {
                //             $scope.setCounts()
                //             toastr.success("Role deleted sucessfully");
                //         } else {
                //             toastr.error('Cannot delete.Users are already assigned');
                //         }
                //     }
                // })
            })
            return false

        }

        self.remove = function(index) {
            self.selectedCurriculum.splice(index, 1);
        };

        self.addRole = function() {
            if (self.selectedCurriculum.length === 0) {
                toastr.error("Please add roles");
                return false
            }
            let send = {
                schoolId : localSchoolId,
                roleList : self.selectedCurriculum
            }
            authService.callAPI("/v0/initial-settings/user-console/roles/assigned/update", "POST", 
            send, function (response) {
                try{
                    console.log(response)
                    if(!response.error){
                        toastr.success("New Role added sucessfully.");
                        self.enableNextBtn = true;
                        self.selectedCurriculum = [];
                        $scope.allSettingRole = response.result.data.data
                        setSettings()
                    }else{
                        console.log(response.error)
                        if (response.error) {
                            if (response.error.error === 'PrivilegeError') {
                                toastr.error("Invalid Data to server.");
                            } else {
                                toastr.error("Please try after some time.");
                            }
                        }
                    }
                }catch(e){
                    console.log(e)
                }
            })
            // Meteor.call("addRolePrivilage", self.selectedCurriculum, Session.get('school_id'), function(error, result) {
            //     if (error) {
            //         if (error.error) {
            //             if (error.error === 'PrivilegeError') {
            //                 toastr.error("Invalid Data to server.");
            //             } else {
            //                 toastr.error("Please try after some time.");
            //             }
            //         }
            //     } else {
            //         toastr.success("New Role added sucessfully.");
            //         self.enableNextBtn = true;
            //         self.selectedCurriculum = [];
            //     }
            // });
        }

        self.dragControlListeners = {
            containment: '#blocks'
        };

        self.sortableCloneOptions1 = {
            containment: '#sortable-container',
            allowDuplicates: true,
            ctrlClone: true
        };

        self.goNext = function() {

            if (self.selectedRoles.length <= 0) {
                toastr.success("please add atleast one role");
                return false;
            }

            if ($scope.btnLabel === "Next") {
                Meteor.call("updateInitialSettingValue", 4, function(error, result) {
                    toastr.success("Successfully saved!");
                    $state.go("checkList")
                });

            } else {
                toastr.success("Updated successfully!");
                $state.go("initialSetting")
            }
        }
        var HierarchyItems = function() {

            this.loadedPages = {};


            this.numItems = 0;


            this.PAGE_SIZE = 50;

            this.fetchNumItems_();
        };


        HierarchyItems.prototype.getItemAtIndex = function(index) {
            var pageNumber = Math.floor(index / this.PAGE_SIZE);
            var page = this.loadedPages[pageNumber];

            if (page) {
                return page[index % this.PAGE_SIZE];
            } else if (page !== null) {
                this.fetchPage_(pageNumber);
            }
        };


        HierarchyItems.prototype.getLength = function() {
            return this.numItems;
        };

        HierarchyItems.prototype.fetchPage_ = function(pageNumber) {
            var hierarchy = this
            if(!hierarchy.loadedPages){
                hierarchy.loadedPages = {}
            }
            hierarchy.loadedPages[pageNumber] = null;
            $timeout(angular.noop, 300).then(angular.bind(this, function() {
                hierarchy.loadedPages[pageNumber] = [];
                var pageOffset = pageNumber * hierarchy.PAGE_SIZE;
                let paginationOpts = {
                    limit: parseInt(hierarchy.PAGE_SIZE),
                    skip: parseInt(pageOffset),
                };
                let match = {
                    pagination_opts : paginationOpts,
                    selector : {
                        $or : [{
                            role_id : $scope.current_role
                        },{
                            role_ids : {
                                $in : [$scope.current_role]
                            }
                        }],
                        school_id : localStorageService.get('school_id')
                    },
                    role_id : $scope.current_role
                }
                authService.callAPI("/v0/hierarchy/get-users-with-child", "POST", match, function (response) {    
                    try{
                        
                        let result = response.result.data.data
                        console.log(result)
                        if (result.length > 0) {
                            // result = _.uniq(result, false, function(one){
                            //     return one._id
                            // })
                            hierarchy.loadedPages[pageNumber] = result
                            $scope.$apply()
                        }
                    }catch(e){
                        console.log(e)
                    }
                    $scope.$apply()
                })
                // Meteor.call('getUsersByRole', $scope.current_role, Session.get('school_id'), paginationOpts, (error, result) => {
                //     if (result.length > 0) {
                //         this.loadedPages[pageNumber] = result
                //         $scope.$apply()
                //     }


                // })


            }));
        };

        HierarchyItems.prototype.fetchNumItems_ = function() {
            var hierarchy = this
            let match = {
                // role_id : $scope.current_role,
                $or : [{
                    role_id : $scope.current_role
                },{
                    role_ids : {
                        $in : [$scope.current_role]
                    }
                }],
                school_id : localStorageService.get('school_id')
            }
            $timeout(angular.noop, 300).then(angular.bind(this, function() {
                authService.callAPI("/v0/hierarchy/get-count-of-users", "POST", match, function (response) {    
                    try{
                        let result = response.result.data.data
                        hierarchy['numItems'] = result
                        $scope.$apply();
                    }catch(e){
                        console.log(e)
                    }
                    $scope.$apply()
                })
            }));
        };


        self.loadMangerUsers = function(role) {
            $scope.current_role = role._id
            $scope.managerUsers = new HierarchyItems();
            //$scope.data=undefined
            $scope.userdata = undefined
            $scope.roleData = role
        }
        self.deleteReportingRole = function() {
                var confirm = $mdDialog.confirm()
                    .title('Delete Role?')
                    .textContent('This will remove all concerned settings')
                    .ariaLabel('Confirm delete')
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {

                    authService.callAPI("/v0/hierarchy/delete-institution-head/"+localSchoolId, "GET",  function (response) {    
                        try{
                            if(response.error){
                                toastr.error("Please try after some time.");
                            }else{
                                $scope.isReportingObj = false
                                $scope.reportingObj = {}
                                toastr.success("Deleted sucessfully");
                            }
                            $scope.$apply()
                        }catch(e){
                            console.log(e)
                        }
                        
                    })
                    // Meteor.call("deleteRoleMappings", Session.get('school_id'), function(err, res) {
                    //     if (err) {
                    //         toastr.error("Please try after some time.");

                    //     } else {

                    //         toastr.success("Deleted sucessfully");
                    //     }
                    // })
                },function() {
                    $scope.status = 'You decided to keep your debt.';
                  })
            }
            /*Meteor.call("getReportingSettings",Session.get('school_id'),(error,result)=>{
                if(result && result.length>0){
                     $scope.reportingObj=result[0]
                     $scope.isReportingObj=true;
                }
            })*/
        self.saveHeadRole = function() {
            var data = {
                "role_name": $scope.roleData.name,
                "role_id": $scope.roleData._id,
                "_id": $scope.userdata
            }
            let match = {
                data : data,
                school_id : localStorageService.get('school_id'),
                academic_year : localStorageService.get('academic_year')
            }
            authService.callAPI("/v0/hierarchy/save-head-role", "POST", match, function (response) {    
                try{
                    console.log(response)
                    let result = response.result.data
                    if(result){
                        toastr.success("Saved successfully")
                    }else{
                        toastr.error(response.error)
                    }
                    
                    $scope.$apply();
                }catch(e){
                    console.log(e)
                }
                $scope.$apply()
            })
            // Meteor.call("saveHeadRole", data, Session.get('school_id'),  localStorage.getItem('activeAcdYear'), function(error, result) {
            //     if (!error)
            //         toastr.success("Saved successfully")
            //     else
                    
            // })
        }


    }

}


class csvUploadController {
    constructor($scope, $stateParams, $mdMedia, $mdDialog, $state, $timeout
        , $q, $log, errorValidatorUtil, localStorageService, authService) {
        'ngInject';

        
        let self = this;
        self.fullSett = undefined;
        function autorun(allData){
            let settingsData = allData.sett
            let acConsoles = allData.acConsoles
            let roleData = allData.roleData
            $scope.settingsData = allData.sett
            $scope.acConsoles = allData.acConsoles
            $scope.roleData = allData.roleData
            self.rolePackage = _.find(settingsData, function(one){
                return one.type == "role"
            })

            self.allSessions = _.filter(settingsData, function(one){
                return one.type == "session"
            })

            self.allCurriculum = _.filter(settingsData, function(one){
                return one.type == "curriculum"
            })

            self.allClassess = _.filter(settingsData, function(one){
                return one.type == "class"
            })

            self.allBatchess = _.filter(settingsData, function(one){
                return one.type == "batch"
            })

            if (self.rolePackage) {
                self.allRoles = _.filter(self.rolePackage.list, function(role) {
                    return (role.name != 'Admin' || role.name === 'Teacher') && role.status === true
                })
            } else {
                return false;
            }

            self.sessions = []
            self.addedSessions = acConsoles

            if (self.addedSessions === undefined || self.addedSessions.length <= 0)
                return false;

            _.each(self.addedSessions, function(eachSessionId) {
                addedSessionsID.push(eachSessionId.session_id)
            })
            addedSessionsID = _.uniq(addedSessionsID);
            _.each(self.allSessions[0].list, function(v) {
                _.each(addedSessionsID, function(k) {
                    if (v._id === k) {
                        var item = {
                            _id: v._id,
                            name: v.name
                        }
                        self.showSessionName.push(item)
                    }
                })
            })
            self.showSessionName = _.uniq(self.showSessionName, function(doc) {
                return doc._id;
            });
        }
        this.$onInit = function () {

            self.fullSett = this.parentCtrl.allSettingRole;
            console.log('sssssssss')
            console.log(self.fullSett)
            let send = {
                school_id : localStorageService.get('school_id')
            }
            authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", 
            {args : send}, function (response) {
                console.log(response)
                try{
                    if(!response.error){
                        
                        autorun(response.result.data.data)
                    }else{
                        console.log(response.error)
                    }
                }catch(e){
                    console.log(e)
                }
            })
        };
        self.fileUploadObj = {};
        $scope.showPreviewBtn = false;
        $scope.showBrowseBtn = false;
        $scope.showDownloadBtn = false;

        let subsEmail = undefined,
            subsAcdemicPck = undefined,
            subsSetting = undefined,
            subsRole = undefined;

        // this.$onInit = () => {
        //     subsEmail = self.subscribe('getAllEmailsOnly')
        //     subsAcdemicPck = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
        //     subsSetting = self.subscribe('getAllAcademicSettings', () => [Session.get('school_id')])
        //     subsRole = self.subscribe('getRolesData', () => [Session.get('school_id')])
        // }

        this.$onDestroy = () => {
            if (subsEmail)
                subsEmail.stop()
            if (subsAcdemicPck)
                subsAcdemicPck.stop()
            if (subsSetting)
                subsSetting.stop()
            if (subsRole)
                subsRole.stop()

            self.fileUploadObj = undefined
            self.selectedsubjs = [];
            self.showSessionName = [];
            self.showCurriculumName = [];
            self.userArry = {};
        }
        let validateBulk = (objToVal) => {
            // console.log(objToVal)
            let retVal = []
            let errors = {}
            // objToVal = {}
            let fields = ["name", "email", "phone", "addrLine1", "addrLine2", "city", "country", "pincode", "username", "initial_settings", "joined_date", "birth_date", "sex", "admission_number", "relation", "parent_email", "role", "spouse", "use_gafe", "Password", "blood_group", "is_employee", "employee_no"]
            _.each(fields, function(o){
                if(objToVal[o]){
                    if(objToVal[o] == ""){
                        objToVal[o] = undefined
                    }
                    objToVal[o] = objToVal[o].trim()
                }
            })
            if(!objToVal.name){
                let err = {}
                err['name'] = "name"
                err['message'] = "Name is required"
                retVal.push(err)
                // objToVal.name.errors['name'] = "Name is required"
            }else{
                if (typeof objToVal.name === 'string' || objToVal.name instanceof String){
                    var n = objToVal.name.length;
                    if(n > 75){
                        objToVal.name.errors['name'] = "Name doesnt exceed 75 chars"
                    }else if( n < 3){
                        objToVal.name.errors['name'] = "Name doesnt less than 3 chars"
                    }else{
                        let patternC = /^(^\w+)[a-zA-Z.\s]*$/
                        let spaceSingle = /^[a-zA-Z]+\s[a-zA-Z]+$/
                        let n = objToVal.name.search(' ')
        
                        if (!patternC.test(objToVal.name)) {
                            objToVal.name.errors['name'] = "Special characters and numericals are not allowed"
                        }
                        if (n !== -1) {
                            // let datVal = patternC.test(this.value)
                            if (!patternC.test(objToVal.name)) {
                                objToVal.name.errors['name'] = "Single space is only allowed"
                            }
                        };
                    }

                }else{
                    let err = {}
                    err['name'] = "name"
                    err['message'] = "Name must be string"
                    retVal.push(err)
                    // objToVal.name.errors['name'] = "Name must be string"
                }
            }
            if(!objToVal.email){
                let err = {}
                // objToVal.errors.email = "Email is reqiured"
                err['name'] = "email"
                err['message'] = "Email is reqiured"
                retVal.push(err)
            }else{
                var n = objToVal.email.length;
                if( n < 5){
                    let err = {}
                    err['name'] = "email"
                    err['message'] = "Name doesnt less than 5 chars"
                    retVal.push(err)
                    // objToVal.errors.email = "Name doesnt less than 5 chars"
                }else{
                    let n = objToVal.email.split('@')
                    if (objToVal.email !== null) {
                            let pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                            let res = pattern.test(objToVal.email);
                            if (!res) {
                                let err = {}
                                err['name'] = "email"
                                err['message'] = "Enter valid e-mail ID"
                                retVal.push(err)
                                // objToVal.errors.email = "Enter valid e-mail ID"
                            }
                    }
                }
            }
            if(!objToVal.phone){
                let err = {}
                err['name'] = "phone"
                err['message'] = "Phone number is reqiured"
                // objToVal.errors.phone = "Phone number is reqiured"
                retVal.push(err)
            }else{
                if(objToVal.phone){
                    let number = objToVal.phone
                    let re = /^[0-9-\s]*$/;
                    let res = number.match(re)
                    if(!res){
                        let err = {}
                        err['name'] = "phone"
                        err['message'] = "Invalid phone number"
                        // objToVal.errors.phone = "Invalid phone number"
                        retVal.push(err)
                    }else{
                        if(number.length < 8 || number.length > 15){
                            let err = {}
                            err['name'] = "phone"
                            err['message'] = "Phone number must be between 8 and 15 characters"
                            retVal.push(err)
                            // objToVal.errors.phone = "Phone number must be between 8 and 15 characters"
                        }else{
                            let re = /^[0-9\s]*$/;
                            let res = number.match(re)
                            let splitCtr = number.split("0")
                            let str = number;
                            if(!res){
                                let err = {}
                                err['name'] = "phone"
                                err['message'] = "Invalid phone number"
                                retVal.push(err)
                                // objToVal.errors.phone = "Invalid phone number"
                            }else{
                                if((splitCtr.length-1) == str.length){
                                    let err = {}
                                    err['name'] = "phone"
                                    err['message'] = "Phone number should not be everything zero"
                                    retVal.push(err)
                                    // objToVal.errors.phone = "Phone number should not be everything zero"
                                }
                            }
                        }
                    }
                }
            }
            let mandatory = ['addrLine1', 'city', 'country', 'pincode']
            _.each(mandatory, function(one){
                if(!objToVal[one] || objToVal[one] == ""){
                    let err = {}
                    err['name'] = one
                    err['message'] = one +" is reqiuired"
                    // objToVal.errors[one] = one +" is reqiuired"
                    retVal.push(err)
                }
            })
            if(objToVal.joined_date){
                if (objToVal.role == "student") {
                    if (!objToVal.joined_date) {
                        let err = {}
                        err['name'] = 'joined_date'
                        err['message'] = "Please enter join date  (YYYY-MM-DD)"
                        retVal.push(err)
                        // objToVal.errors['joined_date'] = "Please enter join date  (YYYY-MM-DD)"
                    } else {
                        let dateChek = new Date(objToVal.joined_date);
                        if (dateChek == 'Invalid Date') {
                            let err = {}
                            err['name'] = 'joined_date'
                            err['message'] = "Please enter join date  (YYYY-MM-DD)"
                            retVal.push(err)
                            // objToVal.errors['joined_date'] = "Please enter join date  (YYYY-MM-DD)"
                        }
                        var regEx = /^\d{4}-\d{2}-\d{2}$/;
                        if (objToVal.joined_date.match(regEx) == null) {
                            let err = {}
                            err['name'] = 'joined_date'
                            err['message'] = "Please enter join date  (YYYY-MM-DD)"
                            retVal.push(err)
                            // objToVal.errors['joined_date'] = "Please enter join date  (YYYY-MM-DD)"
                        }
                    }
                }
            }
            if(objToVal.birth_date){
                if (objToVal.role == "student") {
                    if (!objToVal.birth_date) {
                        let err = {}
                        err['name'] = 'birth_date'
                        err['message'] = "Please enter birth date  (YYYY-MM-DD)"
                        retVal.push(err)
                        // objToVal.errors['birth_date'] = "Please enter birth date  (YYYY-MM-DD)"
                    } else {
                        let dateChek = new Date(objToVal.birth_date);
                        if (dateChek == 'Invalid Date') {
                            let err = {}
                            err['name'] = 'birth_date'
                            err['message'] = "Please enter birth date  (YYYY-MM-DD)"
                            retVal.push(err)
                            // objToVal.errors['birth_date'] = "Please enter birth date  (YYYY-MM-DD)"
                        } else {
                            var d = new Date(objToVal.birth_date);
                            var d1 = new Date();
                            var date1 = d.getFullYear();
                            var age = d1.getFullYear() - d.getFullYear();
                            if (age < 3) {
                                let err = {}
                                err['name'] = 'birth_date'
                                err['message'] = "Invalid Birth date "
                                retVal.push(err)
                                // objToVal.errors['birth_date'] = "Invalid Birth date "
                            }
                            var regEx = /^\d{4}-\d{2}-\d{2}$/;
                            if (objToVal.birth_date.match(regEx) == null) {
                                let err = {}
                                err['name'] = 'birth_date'
                                err['message'] = "Please enter birth date  (YYYY-MM-DD)"
                                retVal.push(err)
                                // objToVal.errors['birth_date'] = "Please enter birth date  (YYYY-MM-DD)"
                            }
                        }
                    }
                }
            }
            if(objToVal.sex){
                if (objToVal.role == "student") {
                    if (!objToVal.sex) {
                        let err = {}
                        err['name'] = 'sex'
                        err['message'] = "Sex is reqiured"
                        retVal.push(err)
                        // objToVal.errors.sex = "Sex is reqiured"
                    }
                }
            }
            if(objToVal.relation){
                if (objToVal.role == "student") {
                    if (!objToVal.sex) {
                        let err = {}
                        err['name'] = 'relation'
                        err['message'] = "Relation is reqiured"
                        retVal.push(err)
                        // objToVal.errors.relation = "Relation is reqiured"
                    }
                }
            }
            if(objToVal.parent_email){
                if (objToVal.role == "student") {
                    if (objToVal.parent_email) {
                        let n = objToVal.parent_email.split('@')
                        if (objToVal.parent_email !== null) {
                                let pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                                let res = pattern.test(objToVal.parent_email);
                                if (!res) {
                                    let err = {}
                                    err['name'] = 'parent_email'
                                    err['message'] = "Enter valid e-mail ID"
                                    retVal.push(err)
                                }
                        }
                        // let err = {}
                        // err['name'] = 'parent_email'
                        // err['message'] = "Enter valid e-mail sID"
                        // retVal.push(err)
                        // objToVal.errors.parent_email = "Enter valid e-mail ID"
                    }
                }
            }
            if(objToVal.spouse && objToVal.role == "student"){
                let patternC = /^(^\w+)[a-zA-Z.\s]*$/
                let spaceSingle = /^[a-zA-Z]+\s[a-zA-Z]+$/
                let n = objToVal.spouse.search(' ')
                if (!patternC.test(objToVal.spouse)) {
                    let err = {}
                    err['name'] = 'spouse'
                    err['message'] = "Please enter spouse name"
                    retVal.push(err)
                    // objToVal.errors.spouse = "Please enter spouse name"
                }
                if (n !== -1) {
                    if (!patternC.test(objToVal.spouse)) {
                        let err = {}
                        err['name'] = 'spouse'
                        err['message'] = "Single space is only allowed"
                        retVal.push(err)
                        // objToVal.errors.spouse = "Single space is only allowed"
                    }
                }
            }
            if(objToVal.use_gafe){
                if(['Y', 'N', 'y', 'n'].indexOf(objToVal.use_gafe) === -1){
                    let err = {}
                    err['name'] = 'use_gafe'
                    err['message'] = "Value is not allowed"
                    retVal.push(err)
                    // objToVal.errors.use_gafe = "Value is not allowed"
                }
            }
            if(objToVal.Password){
                let gafeValue = objToVal.use_gafe
                if (gafeValue) {
                    if (gafeValue == "y" || gafeValue == "Y") {
                        let pwdValue = objToVal.Password
                        if (!pwdValue) {
                            let err = {}
                            err['name'] = 'Password'
                            err['message'] = "Please enter Valid password"
                            retVal.push(err)
                            // objToVal.errors.Password = "Please enter Valid password"
                            
                        } else {
                            if (pwdValue.length < 8) {
                                let err = {}
                                err['name'] = 'Password'
                                err['message'] = "password length should be min 8"
                                retVal.push(err)
                                // objToVal.errors.Password = "password length should be min 8"
                            }
                        }
                    }
                }
            }
            if(!objToVal.blood_group){
                let err = {}
                err['name'] = 'blood_group'
                err['message'] = "Blood group required"
                retVal.push(err)
                // objToVal.errors.blood_group = "Blood group required"
            }else{
                let allowedValues = ["O+","O-","A+","A-","B+","B-","AB-","AB+",
                "O+ve","O-ve","A+ve","A-ve","B+ve","B-ve","AB-ve","AB+ve",
                "A","B","0","AB","a","b","o","ab","ab-ve","ab+ve","a+","a-","a+ve","a-ve","ab-","ab+",
                "o-","o-ve","o+","o+ve","b+","b+ve","b-","b-ve","Ab-","Ab+"
                ]
                if(allowedValues.indexOf(objToVal.blood_group) === -1){
                    let err = {}
                    err['name'] = 'blood_group'
                    err['message'] = "Value is not allowed"
                    retVal.push(err)
                    // objToVal.errors.blood_group = "Value is not allowed"
                }
            }
            if(objToVal.is_employee){
                if (objToVal.role != "student") {
                    let allowedValues = ["y","Y","n","N"]
                     if(!objToVal.is_employee){
                        let err = {}
                        err['name'] = 'is_employee'
                        err['message'] = "Employee status required"
                        retVal.push(err)
                        // objToVal.errors.blood_group = "Employee status required"
                     }else{
                        if(allowedValues.indexOf(objToVal.is_employee.trim()) == -1){
                            let err = {}
                            err['name'] = 'is_employee'
                            err['message'] = "Employee status must be y or n"
                            retVal.push(err)
                            // objToVal.errors.blood_group = "Employee status must be y or n"
                         }
                     }
                }
            }
            // let pageData = UserValidation.simpleSchema().clean(objToVal);
            // delete pageData.$$hashKey
            // UserValidation.simpleSchema().namedContext("ValidationPersonSchema").validate(pageData, {
            //     modifier: false
            // });
            // let context = UserValidation.simpleSchema().namedContext("ValidationPersonSchema");
            // let ret_val = context.invalidKeys();
            // ret_val = _.map(ret_val, function(res) {
            //     return _.extend({
            //         message: context.keyErrorMessage(res.name)
            //     }, res);
            // });
            return retVal
        }
        this.uploadFile = () => {
                var file = this.fileUploadObj.csvUploadFile;
                Papa.parse(file, {
                    complete: function(results) {
                        let data = results ? results.data : [];
                        let countQ = data.length - 1
                        if (countQ > 300) {
                            toastr.error("There are more than 300 entries")
                            return false;
                        }
                        if (data[countQ].length === 1 && data[countQ][0] == '') {
                            data.splice(countQ, 1)
                        }
                        let headers = [];
                        self.questionSet = []
                        _.each(data, function(question, index) {
                            //if (question[0] && question[1]) {
                            let qbObj = {
                                "name": question[0],
                                "email": question[1],
                                "phone": question[2],
                                "addrLine1": question[3],
                                "addrLine2": question[4],
                                "city": question[5],
                                "country": question[6],
                                "pincode": question[7],
                                "use_gafe": question[8],
                                "Password": question[9],
                                "blood_group": question[10],

                            }
                            if ($scope.role == "student") {
                                qbObj.joined_date = question[11]
                                qbObj.birth_date = question[12]
                                qbObj.sex = question[13]
                                qbObj.admission_number = question[14]
                                qbObj.role = $scope.role ? $scope.role : null
                                qbObj.parent_email = question[15] ? question[15] : null
                                qbObj.relation = question[16] ? question[16] : null
                                qbObj.spouse = question[17] ? question[17] : null
                                    // qbObj.father_name = question[18] ? question[18] : null
                                    // qbObj.mother_name = question[19] ? question[19] : null
                            } else {
                                qbObj.is_employee = question[11]
                                qbObj.employee_no = question[12]
                            }
                            if (index !== 0) {
                                let ret_val = validateBulk(qbObj)
                                
                                qbObj.errors = {}
                                qbObj.errCount = 0
                                if (ret_val && ret_val.length > 0) {

                                    for (let key = 0; key <ret_val.length; key++) {
                                        console.log(ret_val[key])
                                        // qbObj.errCount++
                                        qbObj['errors'][ret_val[key].name] = ret_val[key].message
                                    }

                                }
                                self.questionSet.push(qbObj)
                            }
                            if (index === 0) {
                                headers.push(qbObj)
                            }
                            //}
                        })
                        showBulkEntries(self.questionSet);
                    }
                });
            }
            /***********************DropBox**********************************/
        self.selectedsubjs = [];
        let addedSessionsID = [];
        let showSession = [];
        self.showSessionName = [];
        self.showCurriculumName = [];
        self.userArry = {};

        self.getRoleDetails = (id, name) => {
            $scope.roleType = id;
            $scope.csvRole = name
            $scope.role = id
        }

        self.getBrowseBtn = () => {
            let content = $scope.getHeader().join(",")
            let filename = $scope.filename + ".csv"
            download(filename, content)
            $scope.showBrowseBtn = true;
        }

        function download(filename, text) {
            var pom = document.createElement('a');
            pom.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
            pom.setAttribute('download', filename);

            if (document.createEvent) {
                var event = document.createEvent('MouseEvents');
                event.initEvent('click', true, true);
                pom.dispatchEvent(event);
            } else {
                pom.click();
            }
        }
        self.getPreviewBtn = () => {
            $scope.showPreviewBtn = true;
        }
        // $scope.settingsData = allData.sett
        // $scope.acConsoles = allData.acConsoles
        // $scope.roleData = allData.roleData
        self.getCuriculum = function(cid, name) {
            $scope.csvSession = name
            $scope.selectCuriculum = cid;
            $scope.mySession = cid;
            self.showCurriculumName = [];
            let addedCuricullumID = [];
            self.showThisSessions = _.filter($scope.acConsoles, function(one){
                return one.session_id == cid
            })
            _.each(self.showThisSessions, function(v) {
                addedCuricullumID.push(v.curriculum_id)
            })
            addedCuricullumID = _.uniq(addedCuricullumID);
            self.showCurriculumName = [];
            
            _.each(self.allCurriculum[0].list, function(v) {
                _.each(addedCuricullumID, function(k) {
                    if (v._id === k) {
                        var item = {
                            _id: v._id,
                            name: v.name
                        }
                        self.showCurriculumName.push(item)
                    }
                })
            })
        }

        self.getClass = function(sid, name) {
            $scope.csvCurriculum = name
            let cid = $scope.selectCuriculum;
            $scope.classIDs = sid;
            $scope.selectClass = sid;
            $scope.myCuriculum = sid;
            let addedClass = [];
            self.showClassName = [];
            self.showThisClass = _.filter($scope.acConsoles, function(one){
                return one.session_id == cid && 
                one.curriculum_id == sid
            })
            _.each(self.showThisClass[0].xclass, function(classes) {
                addedClass.push(classes._id)
            })
            addedClass = _.uniq(addedClass);
            _.each(self.allClassess[0].list, function(v) {
                _.each(addedClass, function(k) {
                    if (v._id === k) {
                        var item = {
                            _id: v._id,
                            name: v.name
                        }
                        self.showClassName.push(item)
                    }
                })
            })
        }
        self.getBatch = function(bid, name) {
            $scope.csvClass = name
            let s = $scope.selectCuriculum;
            let c = $scope.selectClass;
            $scope.seleBatch = bid;
            $scope.myClass = bid;
            let addedBatchess = [];
            self.showBatchName = [];
            
            self.showThisBatch = _.find($scope.acConsoles, function(one){
                return one.session_id == s && one.curriculum_id == c
            })
            var classDet = _.find(self.showThisBatch.xclass, function(batch) {
                return batch._id === bid
            })
            _.each(self.allBatchess[0].list, function(v) {
                _.each(classDet.batches, function(k) {
                    if (v._id === k) {
                        var item = {
                            _id: v._id,
                            name: v.name
                        }
                        self.showBatchName.push(item)
                    }
                })
            })
        }
        self.getCurrentBatch = (bid, name) => {
            $scope.csvBatch = name
            $scope.selectBatchs = bid;
            $scope.myBatch = bid;
        }

        $scope.getBrowseFileDetails = function(row) {}
        let showBulkEntries = (bulkUploadData, themeObj) => {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'bulkUploadData', 'parentScopeObj', 'themeObj', DialogController],
                    template: csvEntries,
                    parent: angular.element(document.body),
                    locals: {
                        bulkUploadData: bulkUploadData,
                        parentScopeObj: $scope,
                        themeObj: themeObj
                    },
                    clickOutsideToClose: true,
                    fullscreen: true,
                    onShowing: function() {
                        $scope.loading = true
                    },
                    onComplete: function() {
                        $scope.loading = false
                    }
                })
                .then(function() {}, function() {
                    $scope.status = 'You cancelled the dialog.';
                });
            $scope.$watch(function() {
                return $mdMedia('xs') || $mdMedia('sm');
            }, function(wantsFullScreen) {
                $scope.customFullscreen = (wantsFullScreen === true);
            });
        };

        $scope.bulkUpdate = (themeObj) => {
            let eCnt = 0
            // _.each(self.questionSet, function(question_val, question_key) {
            //     let pageData = UserValidation.simpleSchema().clean(question_val);
            //     delete pageData.$$hashKey
            //     UserValidation.simpleSchema().namedContext("ValidationPersonSchema").validate(pageData, {
            //         modifier: false
            //     });
            //     let context = UserValidation.simpleSchema().namedContext("ValidationPersonSchema");
            //     let ret_val = context.invalidKeys();
            //     ret_val = _.map(ret_val, function(res) {
            //         return _.extend({
            //             message: context.keyErrorMessage(res.name)
            //         }, res);
            //     });
            //     question_val.errors = {}
            //     question_val.errCount = 0
            //     if (ret_val.length > 0) {
            //         for (key in ret_val) {
            //             question_val.errCount++
            //                 eCnt++
            //                 question_val['errors'][ret_val[key].name] = ret_val[key].message
            //         }
            //     }
            // })

            self.userObj = () => {
                let dataArry = {
                    "role_id": $scope.role,
                    "session_id": $scope.mySession,
                    "curriculum_id": $scope.myCuriculum,
                    "class_id": $scope.myClass,
                    "batch_id": $scope.myBatch
                }
                $scope.loadingSave = true
                $mdDialog.hide();
                
                let obj = {
                    school_id : localStorageService.get('school_id'),
                    userArry : dataArry,
                    academicyear : localStorageService.get('academic_year'),
                    userSet : self.questionSet
                }
                authService.callAPI("/v0/initial-settings/user-console/users/bulk/upload", "POST", 
                obj, function (response) {
                    console.log(response)
                    try{
                        if(!response.error){
                            let result = response.result.data
                            if (result.limit_over) {
                                toastr.error(" User Limit Over by :" + result.limit);
    
                            } else if (result.status) {
                                if (result.oks.length === 0) {
                                    toastr.error(result.oks.length + " Users Added ");
                                } else {
                                    toastr.success(result.oks.length + " Users Added successfully");
                                }
                                $scope.showPreviewBtn = false;
                                $scope.showBrowseBtn = false;
                                $scope.showDownloadBtn = false;
                                $scope.loading = false
                                self.questionSet = []
                            } else {
                                let countError = self.questionSet.length - result.oks.length
                                toastr.success(result.oks.length + " User/s added " + countError + " User/s already exist ");
                                $scope.loading = false
                            }
                            $scope.loadingSave = false
                        }
                        self.parentCtrl.getCountFromChild()  
                    }catch(e){
                        toastr.error(e)
                        console.log(e)
                    }
                })
            }
            if (eCnt === 0) {
                self.userObj();
            }
        }

        $scope.getArray = [{}];


        $scope.getHeader = function() {
            let content = ["Name", "Email", "Phone", "Addr Line1", "Addr Line2", "City", "Country", "Pincode", "Use gafe(Y/N)", "Password", "Blood Group"]
            if ($scope.role == "student") {
                content.push("DOJ")
                content.push("DOB")
                content.push("Sex")
                content.push("Admission Number")
                content.push("Parent Email")
                content.push("Relation")
                content.push("Spouse")
            }
            if ($scope.role != "student") {
                content.push("Is Employee")
                content.push("Emp Id")
            }
            return content
        };

        $scope.clickFn = function() {};
        $scope.isUser = false;
        $scope.addUser = function() {
            $scope.isUser = $scope.isUser ? false : true;
        }

        $scope.fileHandle = function() {
            if ($scope.role) {
                $scope.showDownloadBtn = true;
                let downloadCSVName;
                if ($scope.role === 'student') {
                    downloadCSVName = $scope.csvRole + '-' +
                        $scope.csvSession + '-' +
                        $scope.csvCurriculum + '-' +
                        $scope.csvClass + '-' +
                        $scope.csvBatch;
                } else {
                    downloadCSVName = $scope.csvRole;
                }
                $scope.filename = downloadCSVName;
            } else {
                toastr.success("Please select the role");
            }
        }

        
    }
}

class DialogController {
    constructor($scope, $mdDialog, bulkUploadData, parentScopeObj, themeObj) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.parentScopeObj = parentScopeObj
        $scope.hide = function() {
            $mdDialog.hide();
        };
        $scope.cancel = function() {
            $mdDialog.cancel();
        };
        $scope.save = function() {
            parentScopeObj.bulkUpdate(themeObj)
        };
    }
}

const csvUploadCtrl = 'csvUploadCtrl';
export default angular.module(name, [
    'wizardStatus'
])

.component("userConsole", {
        template: userConsole,
        transclude: true,
        controllerAs: 'roleManageCtrl',
        controller: ['$scope', '$mdDialog', '$mdToast', '$mdMedia', '$state', '$element', '$attrs', '$compile', '$rootScope', '$timeout', 
        'localStorageService', 'authService', 'CONSTANTS', UserConsole]
    })
    .component(csvUploadCtrl, {
        template: template,
        controllerAs: csvUploadCtrl,
        transclude: true,
        bindings: true,
        require: {
            parentCtrl: '^userConsole'
        },
        controller: ['$scope', '$stateParams', '$mdMedia',
         '$mdDialog', '$state', '$timeout', '$q', '$log', 'errorValidatorUtil','localStorageService', 'authService', csvUploadController]
    })
    .controller('userConsole', UserConsole);


function config($stateProvider) {
    'ngInject';
    $stateProvider.state('userConsole', {
        url: '/userConsole',
        template: '<user-console></user-console>'
    });
}



// WEBPACK FOOTER //
// ./src/app/initial_settings/userconsoleModule.js